import React from 'react';
import { connect } from 'react-redux';

import { togglePopup, toggleSnackBar } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DocsListItem } from 'apps/auth/components/common/components/DocsList/DocsListItem';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import { copyTextToClipboard, resolveArguments } from 'apps/auth/helpers/utils';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const DocsFooter = (props) => {
    const {
        chat_limits_preview,
        sendPhotoViaChat,
        orSendViaEmail,
        waitABit,
        usuallyTakesSomeTime,
        chatTitle,
        emailCopied,
        subjectCopied,
        copyEmail,
        copySubject,
    } = usePageMessages();
    const { profile_form: profile } = useExtra();

    const copyOnClick = (e, label, value) => {
        e.preventDefault();
        const result = copyTextToClipboard(value);
        if (result) {
            props.toggleSnackBar(true, label);
        }
    };

    return (
        <>
            <DocsListItem title={sendPhotoViaChat}>
                <Row>
                    <Button
                        type="button"
                        size="tight"
                        variant="row"
                        caption={orSendViaEmail}
                        negativeMargin
                        onClick={(e) => {
                            e.preventDefault();
                            props.popupRef.current?.open(
                                <SimplePopup text={resolveArguments(chat_limits_preview, profile?.id)} popupRef={props.popupRef}>
                                    <PopupButton
                                        iconName="copy"
                                        text={copyEmail}
                                        onClick={(e1) => {
                                            copyOnClick(e1, emailCopied, 'kyc@paysend.com');
                                        }}
                                    />
                                    <PopupButton
                                        iconName="copy"
                                        text={copySubject}
                                        onClick={(e2) => {
                                            copyOnClick(e2, subjectCopied, `KYC ${profile?.id}`);
                                        }}
                                    />
                                </SimplePopup>,
                            );
                        }}
                    />
                </Row>
            </DocsListItem>
            <DocsListItem title={waitABit}>
                <Text color="secondary">{usuallyTakesSomeTime}</Text>
            </DocsListItem>
            <FixedBottomPanel isRightAligned>
                <Button onClick={() => props.toggleChat(true)} raised={true} size="fit" caption={chatTitle} />
            </FixedBottomPanel>
        </>
    );
};
export default connect(null, { toggleChat, togglePopup, toggleSnackBar })(DocsFooter);
